import { Share2 } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { referralsWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  referralsWeb,
  {
    ShareReflexCard: () => import('./ShareReflexCard'),
    ReferralsPage: () => import('./ReferralsPage'),
    ReferralLandingPage: () => import('./ReferralLandingPage'),
    ReferralClaimer: () => import('./ReferralClaimer'),
  },
  {
    icons: { Share2 },
  },
);
